import React, { useContext } from "react";
import { AuthContext } from "../../components/AuthContext";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../AlertContext";

const app_url = process.env.REACT_APP_FRONTEND_URL;
const server_url = process.env.REACT_APP_BACKEND_URL;

const Settings: React.FC = () => {
  const { session, setSession } = useContext(AuthContext);
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const handleChangePassword = () => {
    if (session?.access_token) {
      const changePasswordUrl = `${app_url}/passwordreset#access_token=${session.access_token}`;
      // change location
      window.location.href = changePasswordUrl;
    } else {
      console.error("No access token found in the current session");
      showAlert("error", "Error: No access token found.");
    }
  };

  const handleDeleteAccount = () => {
    if (
      window.confirm(
        "Are you sure you want to delete your account? This action cannot be undone."
      )
    ) {
      if (session?.access_token) {
        fetch(`${server_url}/deleteAccount`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ access_token: session.access_token }),
        })
          .then((response) => {
            if (response.ok) {
              showAlert("success", "Account deleted successfully");
              setSession(null);
              navigate("/login");
            } else {
              showAlert("error", "Failed to delete account");
            }
          })
          .catch((error) => {
            console.error("Error deleting account:", error);
            showAlert("error", "Error deleting account");
          });
      } else {
        showAlert("error", "Error: No access token found.");
      }
    }
  };

  return (
    <div className="flex flex-col justify-start items-center py-6 px-3 gap-y-6 w-full h-full overflow-y-auto mt-16">
      <div className="bg-white/10 p-6 rounded-xl shadow-lg w-full max-w-md">
        <h2 className="text-3xl font-semibold text-white mb-6">Settings</h2>

        <div className="space-y-6">
          <div>
            <p className="text-white/90 text-lg mb-4">
              Manage your account settings:
            </p>
            <button
              onClick={handleChangePassword}
              className="w-full px-6 py-3 text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none transition duration-300 ease-in-out"
            >
              Change Password
            </button>
          </div>
          <div>
            <button
              onClick={handleDeleteAccount}
              className="w-full px-6 py-3 text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none transition duration-300 ease-in-out"
            >
              Delete Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
